import { StyleDeclarationValue, css } from 'aphrodite';
import * as React from 'react';
import { LoadingSpinner } from '../../../../web/components/LoadingSpinner';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
	styles?: StyleDeclarationValue[];
}

export const IntegrationsSyncingLoader: React.FC<IProps> = props => {
	const { className, styles } = props;
	return (
		<div className={`${css(...(styles || []))} ${className || ''}`}>
			<div className={css(styleSheet.container)}>
				<svg width='180' height='180' fill='none' xmlns='http://www.w3.org/2000/svg'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M90 180c49.706 0 90-40.294 90-90S139.706 0 90 0 0 40.294 0 90s40.294 90 90 90z'
						fill='#F9F9F9'
					/>
					<g opacity='.149'>
						<path
							d='M52 41a3 3 0 013-3h70a3 3 0 013 3v22a3 3 0 01-3 3H55a3 3 0 01-3-3V41z'
							fill='#E8F3F9'
							stroke='#00AAE8'
							strokeWidth='2'
						/>
						<rect x='81.875' y='51.31' width='35.75' height='3.241' rx='1.621' fill='#CAE0EC' />
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M65.55 57.309a2 2 0 01-2.938.25l-2.99-2.75a1.428 1.428 0 011.902-2.131l2.334 2.02 7.34-9.352a1.414 1.414 0 012.233 1.736l-7.88 10.227z'
							fill='#00AAE8'
						/>
						<path
							d='M52 79a3 3 0 013-3h70a3 3 0 013 3v22a3 3 0 01-3 3H55a3 3 0 01-3-3V79z'
							fill='#E8F3F9'
							stroke='#00AAE8'
							strokeWidth='2'
						/>
						<rect x='81.875' y='89.31' width='35.75' height='3.241' rx='1.621' fill='#CAE0EC' />
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M65.55 95.309a2 2 0 01-2.938.25l-2.99-2.75a1.428 1.428 0 011.902-2.131l2.334 2.02 7.34-9.352a1.414 1.414 0 012.233 1.736l-7.88 10.227z'
							fill='#00AAE8'
						/>
						<path
							d='M52 117a3 3 0 013-3h70a3 3 0 013 3v22a3 3 0 01-3 3H55a3 3 0 01-3-3v-22z'
							fill='#fff'
							stroke='#00AAE8'
							strokeWidth='2'
						/>
						<rect x='81.875' y='127.207' width='35.75' height='3.241' rx='1.621' fill='#CAE0EC' />
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M61.315 123.315a6.05 6.05 0 014.304-1.791 6.101 6.101 0 016.095 6.095h1.524c0-4.201-3.417-7.619-7.62-7.619a7.564 7.564 0 00-5.38 2.238l-1.476-1.476v4.571h4.571l-2.018-2.018zm8.609 8.608a6.052 6.052 0 01-4.305 1.792 6.102 6.102 0 01-6.095-6.096h-1.523c0 4.202 3.417 7.619 7.619 7.619a7.561 7.561 0 005.38-2.239l1.477 1.478v-4.572h-4.572l2.019 2.018z'
							fill='#89C947'
						/>
					</g>
				</svg>
				<div className={css(styleSheet.spinnerContainer)}>
					<LoadingSpinner type='large' />
				</div>
			</div>
			<div className={css(styleSheet.infoText)}>
				Sync in progress… this could take a while.
				<br />
				We will email you when we’ve completed the sync.
			</div>
		</div>
	);
};
